module.exports = __webpack_public_path__ + "img/fulltown_animated.a791337d.svg";